// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorToolbar_ycxyP {
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
  background-color: transparent;
  align-items: center;
  position: relative;
  overflow-x: scroll;
}

.editorToolbar_ycxyP::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.editorToolbar_ycxyP::-webkit-scrollbar-thumb {
  background-color: #d1d1d1;
  border-radius: 4px;
}

.editorToolbar_ycxyP::-webkit-scrollbar-thumb:hover {
  background-color: #ababab;
}

.editorToolbar_ycxyP::-webkit-scrollbar-track {
}

.buttonGroup_wPUUa {
  display: flex;
  gap: 5px;
  padding: 0 5px;
  border-right: 1px solid var(--dddddd-border);
  position: relative;
}

.buttonGroup_wPUUa:last-child {
  border-right: none;
}

.formatBtn_P7Vs8 {
  padding: 5px;
  border: 1px solid var(--dddddd-border);
  background: var(--white-color);
  border-radius: 4px;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formatBtn_P7Vs8 img {
  width: 16px;
  height: 16px;
}

.formatBtn_P7Vs8.active_O2ii5 {
  background-color: #233f39;
  color: var(--white-color);
  border-color: #233f39;
}

.formatBtn_P7Vs8.active_O2ii5 img {
  filter: brightness(0) invert(1);
}

select.formatBtn_P7Vs8 {
  min-width: 80px;
  height: 30px;
}

.emailBody_qsLfY {
  width: 100%;
  min-height: 200px;
  border-radius: 8px;
  outline: none;
  overflow-y: auto;
  background-color: var(--white-color);
  box-sizing: border-box;
  background-color: transparent;
  max-height: 200px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
}

.emailBody_qsLfY:empty:before {
  content: "Escriba su mensaje aquí...";
  color: #999;
}

.emailBody_qsLfY blockquote {
  border-left: 3px solid var(--dddddd-border);
  margin: 0;
  padding-left: 10px;
  color: var(--_6-color);
}

.emailBody_qsLfY code {
  background-color: var(--f5-background);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: "Consolas", monospace;
  font-size: 0.9em;
  color: #e83e8c;
  border: 1px solid #e1e1e8;
}

.emojiMenu_BP49Q {
  position: fixed;
  background: var(--white-color);
  border: 1px solid var(--dddddd-border);
  border-radius: 8px;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 5px;
  box-shadow: 0 2px 5px var(--_0000001a-shadow);
  z-index: 1000;
  width: 240px;
}

.emojiButton_PkUwE {
  background: none;
  border: none;
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.emojiButton_PkUwE:hover {
  background-color: var(--f5-background);
}

.ColorPickerContainer_zU6Hn {
  position: relative;
}

.colorPicker_p3tsh {
  display: flex;
  align-items: center;
  background-color: var(--white-color);
  padding: 5px;
  border: 1px solid var(--dddddd-border);
  background: var(--white-color);
  border-radius: 4px;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.colorOptions_jES8z {
  position: fixed;
  display: flex;
  background-color: var(--white-color);
  padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Toolbar/Toolbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;;EAExB;IACE,aAAa;EACf;AACF;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,6CAA6C;EAC7C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd","sourcesContent":[".editorToolbar {\n  display: flex;\n  gap: 10px;\n  padding-bottom: 10px;\n  background-color: transparent;\n  align-items: center;\n  position: relative;\n  overflow-x: scroll;\n}\n\n.editorToolbar::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.editorToolbar::-webkit-scrollbar-thumb {\n  background-color: #d1d1d1;\n  border-radius: 4px;\n}\n\n.editorToolbar::-webkit-scrollbar-thumb:hover {\n  background-color: #ababab;\n}\n\n.editorToolbar::-webkit-scrollbar-track {\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 5px;\n  padding: 0 5px;\n  border-right: 1px solid var(--dddddd-border);\n  position: relative;\n}\n\n.buttonGroup:last-child {\n  border-right: none;\n}\n\n.formatBtn {\n  padding: 5px;\n  border: 1px solid var(--dddddd-border);\n  background: var(--white-color);\n  border-radius: 4px;\n  cursor: pointer;\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.formatBtn img {\n  width: 16px;\n  height: 16px;\n}\n\n.formatBtn.active {\n  background-color: #233f39;\n  color: var(--white-color);\n  border-color: #233f39;\n}\n\n.formatBtn.active img {\n  filter: brightness(0) invert(1);\n}\n\nselect.formatBtn {\n  min-width: 80px;\n  height: 30px;\n}\n\n.emailBody {\n  width: 100%;\n  min-height: 200px;\n  border-radius: 8px;\n  outline: none;\n  overflow-y: auto;\n  background-color: var(--white-color);\n  box-sizing: border-box;\n  background-color: transparent;\n  max-height: 200px;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  \n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.emailBody:empty:before {\n  content: \"Escriba su mensaje aquí...\";\n  color: #999;\n}\n\n.emailBody blockquote {\n  border-left: 3px solid var(--dddddd-border);\n  margin: 0;\n  padding-left: 10px;\n  color: var(--_6-color);\n}\n\n.emailBody code {\n  background-color: var(--f5-background);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: \"Consolas\", monospace;\n  font-size: 0.9em;\n  color: #e83e8c;\n  border: 1px solid #e1e1e8;\n}\n\n.emojiMenu {\n  position: fixed;\n  background: var(--white-color);\n  border: 1px solid var(--dddddd-border);\n  border-radius: 8px;\n  padding: 10px;\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 5px;\n  box-shadow: 0 2px 5px var(--_0000001a-shadow);\n  z-index: 1000;\n  width: 240px;\n}\n\n.emojiButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.emojiButton:hover {\n  background-color: var(--f5-background);\n}\n\n.ColorPickerContainer {\n  position: relative;\n}\n\n.colorPicker {\n  display: flex;\n  align-items: center;\n  background-color: var(--white-color);\n  padding: 5px;\n  border: 1px solid var(--dddddd-border);\n  background: var(--white-color);\n  border-radius: 4px;\n  cursor: pointer;\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.colorOptions {\n  position: fixed;\n  display: flex;\n  background-color: var(--white-color);\n  padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorToolbar": `editorToolbar_ycxyP`,
	"buttonGroup": `buttonGroup_wPUUa`,
	"formatBtn": `formatBtn_P7Vs8`,
	"active": `active_O2ii5`,
	"emailBody": `emailBody_qsLfY`,
	"emojiMenu": `emojiMenu_BP49Q`,
	"emojiButton": `emojiButton_PkUwE`,
	"ColorPickerContainer": `ColorPickerContainer_zU6Hn`,
	"colorPicker": `colorPicker_p3tsh`,
	"colorOptions": `colorOptions_jES8z`
};
export default ___CSS_LOADER_EXPORT___;
